import { type ReactElement } from 'react';

import {
  RiErrorWarningFill,
  RiMoreLine,
  RiSignalCellular1Fill,
  RiSignalCellular2Fill,
  RiSignalCellular3Fill,
} from '@remixicon/react';

import { ObservationsV1IssuePriorityLevel } from '@spotify/confidence-graphql';

export type IssuePriorityIconProps = {
  priority?: ObservationsV1IssuePriorityLevel | null;
};

export const IssuePriorityIcon = ({
  priority,
}: IssuePriorityIconProps): ReactElement => {
  switch (priority) {
    case ObservationsV1IssuePriorityLevel.Critical:
      return <RiErrorWarningFill size={16} aria-hidden />;
    case ObservationsV1IssuePriorityLevel.High:
      return <RiSignalCellular3Fill size={16} aria-hidden />;
    case ObservationsV1IssuePriorityLevel.Medium:
      return <RiSignalCellular2Fill size={16} aria-hidden />;
    case ObservationsV1IssuePriorityLevel.Low:
      return <RiSignalCellular1Fill size={16} aria-hidden />;
    default:
      return <RiMoreLine size={16} aria-hidden />;
  }
};
